import React from "react";

interface ProgressBarProps {
  percentage: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percentage }) => {
  // Convert percentage to number of filled segments (0-7)
  const filledSegments = Math.round((percentage / 100) * 7);

  return (
    <div className="flex gap-1 mb-4">
      {[...Array(7)].map((_, index) => (
        <div
          key={index}
          className={`w-10 h-3 ${
            index < filledSegments ? "bg-black" : "border"
          }`}
        />
      ))}
    </div>
  );
};

export default ProgressBar;
